<template>
    <button class="link btn" @click="abrirCardapio">{{ textoNoBotao }}</button>
</template>

<script>
import { exibirAlertCasaFechada } from "@/utils/AlertaCasaFechada";
import json from "../../assets/mocks/produtos.json"
import { mapGetters } from "vuex";

    export default {

        name: "ButtonAbrirCardapio",

        props: {
            texto: String,
        },

        data() {
            return {
            tasks: [],
            postData: {},
            myJson: json,
            imageURL: this.$store.state.backgroundImage,
            isDelivery: this.$store.state.tipoCardapio === 'delivery',
            isMouseOver: false
        }},
        computed: {
            ...mapGetters({
                casaAberta: "getCasaAberta",
            }),
            textoNoBotao() {
                if (this.$store.state.isMenuEstatico) {
                    return "Abrir Menu"
                } return "Abrir Cardápio"
            }
        },

        methods: {
            async abrirCardapio() {
                if (this.isDelivery && !this.casaAberta) {
                    exibirAlertCasaFechada();
                }

                // const el = document.documentElement;
                // const requestFS = el.requestFullscreen
                //     || el.webkitRequestFullscreen
                //     || el.mozRequestFullScreen;

                // if (requestFS) {
                //     try {
                //         await requestFS.call(el);
                //     } catch (e) {
                //         // fullscreen negado ou não suportado — navega normalmente
                //     }
                // }

                this.$router.push({ name: 'cardapio' });
            },
        }
        }
</script>


<style scoped>

    .link {
        font-size: 16px;
        padding-block: 10px;
        padding-inline: 20px;
        text-decoration: none;
        font-weight: bold;
        font-style: normal;
        color: white;
    }

    .btn {
        position: relative;
        background: linear-gradient(120deg, var(--cor1) 70%, var(--cor1) 60%);
        color: var(--cor-texto);
        border-radius: 20px;
        box-shadow: 0px 6px 8px 8px rgba(0, 0, 0, 0.4);
        border-style: solid;
        border-color: var(--cor1-clara);
    }


</style>